import $ from 'jquery';
import browserCheck from 'outdated-browser-rework';

// Do stuff when page loaded
$(window).ready(() => {
    browserCheck();
});
